import { v4 as uuidv4 } from 'uuid';

/**
 * Generate a cryptographically secure unique tab ID
 * @returns {string} Secure random UUID v4
 */
export const generateTabId = () => {
   return uuidv4();
};

/**
 * Get or generate a session-stable tab ID
 * @returns {string} The tab ID for this session
 */
let sessionTabId = null;
export const getSessionTabId = () => {
   if (!sessionTabId) {
      sessionTabId = generateTabId();
   }
   return sessionTabId;
};
